import { render, staticRenderFns } from "./UnloadingPlaceNumber.vue?vue&type=template&id=c392bb82"
import script from "./UnloadingPlaceNumber.vue?vue&type=script&lang=js"
export * from "./UnloadingPlaceNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports